import { render, staticRenderFns } from "./componentsCheck.vue?vue&type=template&id=6b947cd6&scoped=true&"
import script from "./componentsCheck.vue?vue&type=script&lang=js&"
export * from "./componentsCheck.vue?vue&type=script&lang=js&"
import style0 from "./componentsCheck.vue?vue&type=style&index=0&id=6b947cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b947cd6",
  null
  
)

export default component.exports